"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARSING_CONTROL_MAP = exports.PARSING_MAP = void 0;
// TODO(sangmuk): number/name이 꼭 필요한지 확인할 것.
// C3: { name: 'number', korName: '통제번호' },
// C4: { name: 'name', korName: '통제활동명' },
exports.PARSING_MAP = {
    Overview: {
        executor: { pos: 'C6', korName: '통제 평가자' },
        createDate: { pos: 'C7', korName: '작성일자' },
        populationCount: { pos: 'C9', korName: '모집단 항목수' },
        samplingCount: { pos: 'C10', korName: '샘플링 항목수' },
        validCount: { pos: 'C11', korName: '유효 항목수' },
        invalidCount: { pos: 'C12', korName: '비유효 항목수' },
        testResult: { pos: 'C13', korName: '운영 테스트결과' }
    },
    '모집단 및 샘플링': {
        populationDescription: { pos: 'C4', korName: '모집단 파일 및 설명' },
        populationCompleteness: { pos: 'C6', korName: '모집단의 완전성 확인' },
        samplingMethod: { pos: 'C11', korName: '샘플링 방법' },
        populationTableColumnCount: { pos: 'C13', korName: '항목당 속성수(열)' },
        samplingResult: { pos: 'B19', korName: '샘플링 결과' } // TableContent
    },
    '운영평가 수행': {
        samplingAttributeCount: { pos: 'C4', korName: '테스트 속성수' },
        attributeContents: { pos: 'B12', korName: '테스트 수행기준' },
        testContents: { pos: 'B', nth_from_above: 4, korName: '테스트 수행 내역' },
        controlException: { pos: 'C', nth_from_above: 8, korName: '식별된 예외사항 기재' }
    }
};
exports.PARSING_CONTROL_MAP = {
    id: -1,
    name: -1,
    goal: -1,
    narrative: -1,
    Yes: -1,
    일별수시: -1,
    수동통제: -1,
    TOC_Population: -1,
    TOC_Completeness: -1,
    TOC_TestProperties: -1,
    TOC_Exception: -1,
    TOC_Evidence: -1,
    TOC_Procedure: -1
};
//# sourceMappingURL=OperationExcelConfigs.js.map